// client/src/pages/BenefitsPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';
import { Navigate } from 'react-router-dom';

function BenefitsPage() {
  const { isSignedIn } = useAuth();
  
  // If user is signed in, redirect to dashboard
  if (isSignedIn) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return (
    <div className="benefits-page">
      {/* Header */}
      <section className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white py-16 w-screen right-[50%] relative left-[50%] right-[50%] mx-[-50vw]">
  <div className="container max-w-4xl mx-auto px-6 text-center">
    <h1 className="text-4xl md:text-5xl font-bold mb-4">Why Choose BoxyQR</h1>
    <p className="text-xl max-w-3xl mx-auto mb-8">
      Discover the benefits of our all-in-one platform and find the perfect plan for your needs
    </p>
    
    <div className="mt-4 flex flex-col items-center">
      <Link to="/sign-up" className="bg-white text-blue-700 border-2 border-white hover:bg-blue-200 hover:text-blue-800 px-10 py-5 rounded-lg font-semibold transition duration-200">
      Create for Free
      </Link>
      
      <p className="mt-8 text-sm opacity-80">No credit card required • QR codes & link tracking • Real-time analytics</p>
    </div>
  </div>
</section>

      {/* Key Benefits */}
  

      {/* Comparison Table */}
      <section className="py-12 bg-gray-50 w-screen right-[50%] relative left-[50%] right-[50%] mx-[-50vw]">
        <div className="container  max-w-6xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center mb-12">How BoxyQR Compares</h2>
          <div className="overflow-x-auto ounded-lg shadow-md">
            <table className="w-full bg-white rounded-lg shadow-md">
              <thead>
                <tr className="bg-gray-100">
                  <th className="px-6 py-4 text-left font-semibold text-gray-700">Features</th>
                  <th className="px-6 py-4 text-center font-semibold text-gray-700">Basic QR Services</th>
                  <th className="px-6 py-4 text-center font-semibold text-blue-700">BoxyQR</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-t">
                  <td className="px-6 py-4 text-gray-700">Create QR Codes</td>
                  <td className="px-6 py-4 bg-gray-50 text-center"><span className="text-xl text-blue-700">✓</span></td>
                  <td className="px-6 py-4 text-center bg-green-50"><span className="text-xl text-blue-700">✓</span></td>
                </tr>
                <tr className="border-t">
                  <td className="px-6 py-4 text-gray-700">Brand Customization</td>
                  <td className="px-6 py-4 bg-gray-50  text-center"><span className="text-yellow-800">Limited</span></td>
                  <td className="px-6 py-4 text-center bg-green-50"><span className="text-xl text-blue-700">✓</span></td>
                </tr>
                <tr className="border-t">
                  <td className="px-6 py-4 text-gray-700">Unified Dashboard</td>
                  <td className="px-6 py-4 bg-gray-50 text-center"><span className="text-yellow-800">Limited</span></td>
                  <td className="px-6 py-4 text-center bg-green-50"><span className="text-xl text-blue-700">✓</span></td>
                </tr>
                <tr className="border-t">
                  <td className="px-6 py-4 text-gray-700">Dynamic URL Updates</td>
                  <td className="px-6 py-4 bg-gray-50 text-center"><span className="text-xl text-red-500">✗</span></td>
                  <td className="px-6 py-4 text-center bg-green-50"><span className="text-xl text-blue-700">✓</span></td>
                </tr>
                <tr className="border-t">
                  <td className="px-6 py-4 text-gray-700">Geo-Location Data</td>
                  <td className="px-6 py-4 bg-gray-50 text-center"><span className="text-xl text-red-500">✗</span></td>
                  <td className="px-6 py-4 text-center bg-green-50"><span className="text-xl text-blue-700">✓</span></td>
                </tr>
                
                <tr className="border-t">
                  <td className="px-6 py-4 text-gray-700">Device Analytics</td>
                  <td className="px-6 py-4 bg-gray-50 text-center"><span className="text-xl text-red-500">✗</span></td>
                  <td className="px-6 py-4 text-center bg-green-50"><span className="text-xl text-blue-700">✓</span></td>
                </tr>
                <tr className="border-t">
                  <td className="px-6 py-4 text-gray-700">AI Product Scanner</td>
                  <td className="px-6 py-4 bg-gray-50  text-center"><span className="text-xl text-red-500">✗</span></td>
                  <td className="px-6 py-4 text-center bg-green-50"><span className="text-xl text-blue-700">✓</span></td>
                </tr>
              </tbody>
            </table>
          </div>
          
        </div>
        <div className="container max-w-5xl mx-auto mt-10 px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">Unified Platform</h3>
              <p className="text-gray-600">
                Track both QR codes and shortened links in one seamless dashboard. No need for multiple tools or services.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">Dynamic Updates</h3>
              <p className="text-gray-600">
                Change where your QR codes and links redirect to anytime, without reprinting or resharing. Save time and resources.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">Detailed Analytics</h3>
              <p className="text-gray-600">
                Get comprehensive insights with geographic location data, device breakdowns, and time-based engagement metrics.
              </p>
            </div>
          </div>

          {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">Brand Customization</h3>
              <p className="text-gray-600">
                Personalize your QR codes with custom colors, logos, and designs that match your brand identity.
              </p>
            </div> */}

            {/* <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">Team Collaboration</h3>
              <p className="text-gray-600">
                Collaborate with team members to manage campaigns, share analytics, and optimize performance together.
              </p>
            </div> */}

            {/* <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">Security & Privacy</h3>
              <p className="text-gray-600">
                Enterprise-grade security with encrypted data, private analytics, and compliance with privacy regulations.
              </p>
            </div> */}
          {/* </div> */}
        </div>
      </section>
     
      {/* Pricing Plans */}
      <section className="py-12 bg-gray-50 w-screen right-[50%] relative left-[50%] right-[50%] mx-[-50vw]">
        <div className="container max-w-6xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center mb-4">The Most Affordable Advanced Solution</h2>
          <p className="text-xl text-center text-gray-600 mb-12 max-w-3xl mx-auto">
          Choose the perfect plan for your needs, all plans include core tracking features.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Free Plan */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200">
              <div className="bg-gray-50 p-6 text-center border-b">
                <h3 className="text-2xl font-bold mb-1">Basic</h3>
                {/* <p className="text-gray-600 mb-4">For personal use</p> */}
                <div className="text-3xl font-bold mb-2">Always Free</div>
                <p className="text-gray-600">Start your journey</p>
              </div>
              <div className="p-6">
                <ul className="space-y-3 mb-6">
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>3 QR codes</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>10 Trackable links</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Basic analytics</span>
                  
                  </li>
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Full customization</span>
                  </li>
                </ul>
                <Link to="/sign-up" className="block text-center font-semibold bg-indigo-600 hover:bg-indigo-700 text-white py-4 px-4 rounded-lg font-medium transition-colors duration-200">
                  Start Now
                </Link>
              </div>
              <div className=" block text-center mb-1 text-xs font-medium text-gray-400">No Credit card required </div>

            </div>

            {/* Plus PLAN */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200">
              <div className="bg-gray-50 p-6 text-center border-b">
                <h3 className="text-2xl font-bold mb-1">Plus</h3>
                {/* <p className="text-gray-600 mb-4">For personal + professionals</p> */}
                <div className="text-4xl font-bold mb-2">$10<span className="absolute mt-1 text-xs text-gray-500 font-normal">*</span><span className="text-xl font-normal">/mo</span></div>
                <p className="text-gray-600">Expand and grow</p>
              </div>
              <div className="p-6">
                <ul className="space-y-3 mb-6">
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>100 QR codes</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>500 Trackable links</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Advanced analytics</span>
                  
                  </li>
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Full customization</span>
                  </li>
                </ul>
                {/* <Link to="/sign-up" className="block text-center bg-gray-200 hover:bg-gray-300 text-gray-800 py-2 px-4 rounded-lg font-medium transition-colors duration-200">
                  Get Started
                </Link> */}
              </div>
            </div>

            {/* Pro Plan */}
            <div className="bg-white rounded-lg shadow-xl border-2 border-gray-200 z-10">
              <div className="bg-indigo-50 p-6 text-center border-b relative">
                <div className="absolute top-0 inset-x-0 transform -translate-y-1/2 flex justify-center">
                  {/* <span className="bg-indigo-500 text-white text-sm font-semibold py-1 px-4 rounded-full shadow-md">
                    Most Popular
                  </span> */}
                </div>
                <h3 className="text-2xl font-bold mb-1">Advanced</h3>
                {/* <p className="text-gray-600 mb-4">For professionals</p> */}
                <div className="text-4xl font-bold mb-2">$45 <span className="absolute mt-1 text-xs text-gray-500 font-normal">*</span><span className="text-xl font-normal">/mo</span></div>
                <p className="text-gray-600">Small business needs</p>
              </div>
              <div className="p-6">
                <ul className="space-y-3 mb-6">
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>500 QR codes</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>1000 trackable links</span>
                  </li>
                  {/* <li className="flex items-start">
                    <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Unlimited scans and clicks</span>
                  </li> */}
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Advanced analytics</span>
                  </li>
                  {/* <li className="flex items-start">
                    <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>1-year data retention</span>
                  </li> */}
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Full customization</span>
                  </li>
                  {/* <li className="flex items-start">
                    <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Priority support</span>
                  </li> */}
                </ul>
{/* 
                <Link to="/sign-up" className="block text-center bg-gray-200 hover:bg-gray-300 text-gray-800 py-2 px-4 rounded-lg font-medium transition-colors duration-200">
                  Get Started
                </Link> */}
              </div>
            </div>

            {/* Business Plan */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200">
              <div className="bg-gray-50 p-6 text-center border-b">
                <h3 className="text-2xl font-bold mb-1">Business</h3>
                <div className="text-2xl font-bold mb-2">Custom Pricing</div>
                <p className="text-gray-600">Custom pricing to fit your needs</p>
              </div>
              <div className="p-6">
                <ul className="space-y-3 mb-6">
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Fits your QR code & link needs</span>
                  </li>
                  {/* <li className="flex items-start">
                    <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Redemtion code access</span>
                  </li> */}
                  {/* <li className="flex items-start">
                    <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg> 
                    <span>User verification - no need to print thousands of unique QR codes</span>
                  </li> */}
                  {/* <li className="flex items-start">
                    <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Unlimited data retention</span>
                  </li> */}
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Enterprise analytics</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="h-5 w-5 text-green-500 mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Team management</span>
                  </li>
                </ul>
                <a 
  href="mailto:sales@boxyqr.com?subject=BoxyQR Sales Inquiry&body=Hello BoxyQR Sales Team,%0A%0AI'm interested in learning more about your services.%0A%0ACompany: %0APhone: %0AWebsite: " 
  className="block text-center bg-gray-200 hover:bg-gray-300 text-gray-800 py-2 px-4 rounded-lg font-medium transition-colors duration-200"
>
  Contact Sales
</a>
              </div>
            </div>
          </div>
        </div>
        <p className=" block text-center mt-10 mb-8 text-xs font-medium text-gray-400">*Taxes not included in pricing </p>

      </section>



      {/* FAQ Section */}
      <section className="py-16 bg-gray-50 w-screen right-[50%] relative left-[50%] right-[50%] mx-[-50vw]">
        <div className="container max-w-4xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-center mb-12">Frequently Asked Questions</h2>
          <div className="space-y-6">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold mb-2">What makes BoxyQR different from other tracking solutions?</h3>
              <p className="text-gray-600">
                BoxyQR uniquely combines QR code and link tracking in one platform with dynamic destination updates, meaning you can change where your QR codes or links point to without reprinting or resharing them.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold mb-2">Can I try BoxyQR before committing to a paid plan?</h3>
              <p className="text-gray-600">
                Yes! You can start with our Free Basic plan, you get 3 free QR codes and 10 trackable links, no credit card required.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold mb-2">What kind of analytics do you provide?</h3>
              <p className="text-gray-600">
                We provide detailed insights on scan/click counts, geographic locations down to city level, device types used, and conversion metrics to help you optimize your marketing.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold mb-2">Can I customize my QR codes to match my brand?</h3>
              <p className="text-gray-600">
                Absolutely! You can fully customize your QR codes with brand colors, logos, and custom designs while maintaining perfect scannability.
              </p>
            </div>
            {/* <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold mb-2">Is there a limit to how many scans or clicks I can track?</h3>
              <p className="text-gray-600">
                No, there's no limit to the number of scans or clicks we track, regardless of which plan you choose. Our system is built to handle any volume of traffic.
              </p>
            </div> */}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white py-16 w-screen right-[50%] relative left-[50%] right-[50%] mx-[-50vw]">
        <div className="container max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-4">Ready to get started?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Join others using BoxyQR to gain valuable insights and improve marketing performance.
          </p>
          <div className="flex justify-center p-3">
            <div className="grid w-full max-w-2xl md:grid-cols-2 gap-4 mb-1 ">
            <Link to="/sign-up" className="bg-white text-blue-700 border-2 border-white hover:bg-blue-200 hover:text-blue-800 px-10 py-5 rounded-lg font-semibold transition duration-200">
            Create for Free
              </Link>
              
              <a 
  href="mailto:sales@boxyqr.com?subject=BoxyQR Sales Inquiry"  
  className="flex bg-transparent justify-center border-2 text-white border-white hover:bg-blue-600 hover:text-white px-10 py-5 rounded-lg font-semibold text-center transition duration-200">
              Contact Sales
              </a>
              
            </div>
          </div>
          <p className="mt-3 justify-center w-full text-center text-sm opacity-80">QR codes & link tracking • Real-time analytics</p>
          
        </div>
      </section>
    </div>
  );
}

export default BenefitsPage;